import { config } from "../../Config";

const getDistinctExtensionsCategories = async () => {
    const url = config.getDistinctExtensionsCategories;

    try {
        const response = await fetch(url, {
            method: "GET",
        });

        if (!response.ok) {
            throw new Error(`Failed to fetch categories. Status: ${response.status}`);
        }

        const data = await response.json();
        if (!data.categories || !Array.isArray(data.categories)) {
            throw new Error("Invalid response structure: 'categories' not found or not an array.");
        }

        return data.categories;
    } catch (error) {
        // console.error("Error fetching distinct extension categories:", error);
        throw error;
    }
};

export default getDistinctExtensionsCategories;
